<template>
  <div>
    <common-dialog
      ref="dialog"
      width="98%"
      title="添加 委外费用单"
      id-key="OutPocCostId"
      line-form
      show-save-button
      :data="data"
      :form-rules="rules"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :save-func="()=>{}"
      :before-save="onBeforeSave"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="isMB?24:8">
              <!-- 后面补充 -->
              <el-form-item label="外协单位" prop="TradeUnitId">
                <!-- <outsourcer v-model="data.TradeUnitId" /> -->
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:8">
              <el-form-item label="单据编号" prop="DocNo">
                <span v-if="Mode==0" class="detail-span">{{data.DocNo}}</span>
                <el-input v-else v-model="data.DocNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:8">
              <el-form-item label="单据日期" prop="DocDate">
                <el-date-picker
                  v-model="data.DocDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :editable="false"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <div class="row-tb-head" style="margin-top: 10px;">
          <span>明细列表</span>
          <div style="float: right;">
            <el-button type="primary" icon="el-icon-plus" @click="addRow">添加</el-button>
          </div>
        </div>
        <el-table class="table-line tb-c-head" show-summary :data="data.RpOutPocCostDts" border>
          <!-- <el-table-column label="生产阶段" min-width="90">
            <template slot-scope="{row}">
              <span v-if="row.Stage==0">注塑</span>
              <span v-if="row.Stage==1">胶件加工</span>
              <span v-if="row.Stage==2">配件装配</span>
              <span v-if="row.Stage==3">产品装配</span>
              <span v-if="row.Stage==4">产品组装</span>
            </template>
          </el-table-column>-->
          <el-table-column label="工单编号" min-width="150" show-overflow-tooltip>
            <template slot-scope="{row}">{{row.WorkDocNo}}</template>
          </el-table-column>
          <!-- <el-table-column label="工序" min-width="130" show-overflow-tooltip>
            <template slot-scope="{row}">{{row.ProcessNo}}</template>
          </el-table-column>-->
          <el-table-column label="产品编号" min-width="150">
            <template slot-scope="{row}">{{row.ProductNo}}</template>
          </el-table-column>
          <el-table-column label="产品名称" min-width="150">
            <template slot-scope="{row}">{{row.ProductName}}</template>
          </el-table-column>
          <el-table-column label="产品规格" prop="ProductSpec" min-width="100" />
          <el-table-column label="产品单位" prop="UnitName" min-width="90" />
          <el-table-column label="颜色" prop="ColorName" min-width="90" />
          <el-table-column label="数量" prop="Quantity" width="120">
            <template slot-scope="{row}">
              <el-input @input="onInput(row,'Quantity')" v-model="row.Quantity"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="加工单价" prop="PocUnitPrice" width="120">
            <template slot-scope="{row}">
              <el-input @input="onInput(row,'PocUnitPrice')" v-model="row.PocUnitPrice"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="加工金额" prop="PocAmount" width="120">
            <template slot-scope="{row}">{{row.PocAmount}}</template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="60px">
            <template slot-scope="{row, $index}">
              <el-button type="text" @click="del(row,$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <select-dialog ref="selectDialog" @select="setRows" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
// import outsourcer from "@/components/production/ticketmanagement/outsourcer/select";
import selectDialog from "./selectDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    // outsourcer,
    selectDialog,
  },
  data() {
    return {
      api: require("@/api/rp/outPocCost").default,
      code_api: require("@/api/sy/serialCode").default,
      data: {
        OutPocCostId: 0,
        DocNo: "", //单据编号
        DocDate: this.$commonJs.getToday(),
        TradeUnitId: null, //往来单位Id
        TradeUnitName: "",
        BusinessTypeId: null, //业务类型
        InvoiceType: null, //票据类型
        ClerkId: null, //经办人
        ClerkName: "",
        Amount: null, //金额
        TaxAmount: null, //税额
        IncTaxAmount: null, //含税金额
        PayAmount: null, //付款金额
        RemainAmount: null, //未付金额
        Remark: "", //备注
        RpOutPocCostDts: [], //明细
      },
      DelRpOutPocCostDts: [],
      Mode: 0,
      rules: {
        DocNo: [{ required: true, message: "单据编号不能为空" }],
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        TradeUnitId: [{ required: true, message: "请选择外协单位" }],
      },
    };
  },
  methods: {
    onCreateOpened(data) {
      console.log("添加", data);
      // this.data.BusinessType = data.BusinessType;
      this.code_api.previewNo("委外费用单").then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取委外费用单编号失败");
        }
      });
    },
    onEditOpened(data) {
      this.data.RpOutPocCostDts.forEach((x) => (x.T = null));
    },
    addRow() {
      if (!this.data.TradeUnitId) {
        this.$message.warning("请先选择外协单位");
        return;
      }
      console.log("选择待结算加工信息");
      this.$refs.selectDialog.openCreate(this.data);
    },
    setRows(data) {
      console.log("设置加工信息", data);
      data.forEach((x) => {
        this.data.RpOutPocCostDts.push({
          OutPocCostDtsId: 0,
          OutPocCostId: this.data.OutPocCostId,
          // Stage: x.Stage,
          SourceDocId: x.ProductInDocId, //入库单Id
          SourceDtsId: x.ProductInDtsId, //入库单明细Id
          SourceType: 0,
          // ProcessId: x.ProcessId,
          // ProcessName: x.ProcessName,
          WorkDocNo: x.WorkDocNo,
          // MaterialId: x.MaterialId,
          // MaterialNo: x.MaterialNo,
          ProductId: x.ProductId,
          ProductNo: x.ProductNo,
          ProductName: x.ProductName,
          ProductSpec: x.ProductSpec,
          UnitName: x.UnitName,
          ColorName: x.ColorName,
          Quantity: x.Quantity,
          PocUnitPrice: null,
          PocAmount: null,
          T: 0,
        });
      });
    },
    delRow(row, index) {
      if (row.T != 0) this.DelRpOutPocCostDts.push({ ...row, T: 2 });
      this.data.RpOutPocCostDts.splice(index, 1);
    },
    onInput(row, type) {
      row.T = row.T == 0 ? 0 : 1;
      row[type] = this.$commonJs.obj.toNumber(row[type]);
      // console.log("input", row);
      row.PocAmount = row.Quantity * row.PocUnitPrice;
    },
    onBeforeSave() {
      if (this.data.RpOutPocCostDts.length == 0) {
        this.$message.warning("明细列表不能为空");
        return false;
      }
      var quantity = this.data.RpOutPocCostDts.some((x) => x.Quantity <= 0);
      if (quantity) {
        this.$message.warning("明细列表 - 数量不能为空且需大于0");
        return false;
      }
      var pocUnitPrice = this.data.RpOutPocCostDts.some(
        (x) => x.PocUnitPrice <= 0
      );
      if (pocUnitPrice) {
        this.$message.warning("明细列表 - 加工单价不能为空且需大于0");
        return false;
      }

      var data = this.$commonJs.obj.removeNullKey(this.data);
      data.RpOutPocCostDts = data.RpOutPocCostDts.filter((x) => x.T != null);
      this.DelRpOutPocCostDts.forEach((x) => data.RpOutPocCostDts.push(x));

      console.log("onBeforeSave", JSON.parse(JSON.stringify(data)));
      this.$refs.dialog.isLoading = true;
      this.api.save(data).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
      this.data.RpOutPocCostDts = [];
      this.DelRpOutPocCostDts = [];
    },
  },
};
</script> 